import React from 'react';
import { BusinessPlanType } from '@prisma/client';
import useUser from '../../hooks/global/useUser';
import { isUserAdminOrManager } from '../../utils/global/helper';
import TabBar from '../filtering/TabBar';
import { TabInt } from '../../interfaces';
import NotificationsSettingsTab from './NotificationsSettingsTab';

enum Tab {
  employee = 0,
  manager = 1,
}

function NotificationsSettings() {
  const { user } = useUser();

  const [tab, setTab] = React.useState<Tab>(Tab.employee);

  const employeeTab = React.useMemo<TabInt>(
    () => ({
      id: 'employee',
      label: 'Notifications',
      component: <NotificationsSettingsTab type="employee" />,
    }),
    [],
  );

  const managerTab = React.useMemo<TabInt>(
    () => ({
      id: 'manager',
      label: 'Manager Notifications',
      hidden:
        !user ||
        !isUserAdminOrManager(user) ||
        user?.business?.type !== BusinessPlanType.STUDIO,
      component: <NotificationsSettingsTab type="manager" />,
    }),
    [user],
  );

  return (
    <TabBar
      tabs={[employeeTab, managerTab]}
      currentTab={tab}
      changeTab={setTab}
      hideWhenOnlyOneTab
      noTopMargin
    />
  );
}

export default NotificationsSettings;
